import { render, staticRenderFns } from "./NewConsignmentReturn.vue?vue&type=template&id=595b361c&"
import script from "./NewConsignmentReturn.vue?vue&type=script&lang=js&"
export * from "./NewConsignmentReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewConsignmentReturn.vue"
export default component.exports